export const setCssValueUnity = (value: number | string | undefined) => {
  if (!value) {
    return undefined
  }
  return typeof value === 'number' ? `${value}px` : value
}

export const convertSizePixels = (value: string | number, containerWidth = 0) => {
  if (typeof value === 'number') {
    return value
  }

  if (value.endsWith('px')) {
    return parseFloat(value)
  }

  if (value.endsWith('%')) {
    return (containerWidth * parseFloat(value)) / 100
  }

  return parseFloat(value)
}
